var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoAboutUs = function SvgLogoAboutUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.499 15.667h1.666v1.667H.832v-1.667h1.667V1.5c0-.46.373-.833.833-.833h13.333c.46 0 .834.373.834.833zm-1.667 0V2.334H4.165v13.333zm-9.167-7.5h2.5v1.667h-2.5zm0-3.333h2.5V6.5h-2.5zm0 6.666h2.5v1.667h-2.5zm4.167 0h2.5v1.667h-2.5zm0-3.333h2.5v1.667h-2.5zm0-3.333h2.5V6.5h-2.5z"
  })));
};
export default SvgLogoAboutUs;